import { createContext } from 'react';

const UserContext = createContext({
    name: "FIDELIS AGBA",
    username: "fid37is",
    phoneNumber: "+2348085952266"
});

export default UserContext;